export const ADD = 'ADD';
export const MINUS = 'MINUS';
export const INITIALIZATION = 'INITIALIZATION';
export const FETCH = 'FETCH';


/** WEBPACK FOOTER **
 ** ./src/actionTypes/countNumber/index.js
 **/